/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Already_AssignedInputs */

const en_adm_err_already_assigned = /** @type {(inputs: Adm_Err_Already_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This role is already assigned here.`)
};

const de_adm_err_already_assigned = /** @type {(inputs: Adm_Err_Already_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Rolle ist hier bereits zugewiesen.`)
};

/**
* | output |
* | --- |
* | "This role is already assigned here." |
*
* @param {Adm_Err_Already_AssignedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_already_assigned = /** @type {((inputs?: Adm_Err_Already_AssignedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Already_AssignedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_already_assigned(inputs)
	return en_adm_err_already_assigned(inputs)
});